import { render, staticRenderFns } from "./HousingAudit.vue?vue&type=template&id=4f438e33&scoped=true&"
import script from "./HousingAudit.vue?vue&type=script&lang=js&"
export * from "./HousingAudit.vue?vue&type=script&lang=js&"
import style0 from "./HousingAudit.vue?vue&type=style&index=0&id=4f438e33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f438e33",
  null
  
)

export default component.exports